import { Combobox, ComboboxOption } from 'components/ui/combobox';
import { COLLAB_CLUB_SKILLS } from 'constants/collab-club';
import { Artist } from 'types';
import { useTranslation } from 'react-i18next';

interface SkillsStepProps {
  profile: Artist;
  value: string[];
  onChange: (value: string[]) => void;
}

export function SkillsStep({ profile, value, onChange }: SkillsStepProps) {
  const { t } = useTranslation('collab-club');
  const skillOptions: ComboboxOption[] = COLLAB_CLUB_SKILLS.map((skill) => ({
    value: skill,
    label: skill.charAt(0).toUpperCase() + skill.slice(1), // Capitalize first letter
  }));

  return (
    <div className="space-y-6">
      <div className="">
        <h3 className="text-lg font-semibold text-gray-900">{t('select_skills')}</h3>
      </div>

      <div>
        <Combobox
          options={skillOptions}
          value={value}
          onValueChange={(v) => onChange(v as string[])}
          placeholder={t('select_placeholder')}
          searchPlaceholder={t('search_placeholder_generic')}
          emptyText={t('nothing_found')}
          multiple={true}
        />
      </div>
    </div>
  );
}
